import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import {
  TextField,
  Button,
  Container,
  Typography,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  Paper,
  Divider,
  Box
} from '@mui/material';
import { apiFetch } from '../utils/api';
import UploadIcon from '@mui/icons-material/CloudUpload';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import '../App.css';

const deviceTypeBrandModelMap = {
  'Mobile Device': {
    Apple: ['iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16', 'iPhone 16 Plus',
      'iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15', 'iPhone 15 Plus',
      'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14', 'iPhone 14 Plus',
      'iPhone SE (2022)', 'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13',
      'iPhone 13 mini', 'iPhone 12 Pro Max', 'iPhone 12 Pro', 'iPhone 12',
      'iPhone 11 Pro Max', 'iPhone 11'],
    Samsung: [
  // Flagships
  'Galaxy S24 Ultra', 'Galaxy S24+', 'Galaxy S24',
  'Galaxy S23 Ultra', 'Galaxy S23+', 'Galaxy S23',
  'Galaxy S22 Ultra', 'Galaxy S22+', 'Galaxy S22',
  'Galaxy S21 Ultra', 'Galaxy S21+', 'Galaxy S21',
  'Galaxy S20 Ultra', 'Galaxy S20+', 'Galaxy S20',
  'Galaxy S10+', 'Galaxy S10', 'Galaxy S10e',
  'Galaxy S9+', 'Galaxy S9', 'Galaxy S8+', 'Galaxy S8',
  'Galaxy S7 Edge', 'Galaxy S7',

  // Foldables
  'Galaxy Z Fold 5', 'Galaxy Z Fold 4', 'Galaxy Z Fold 3',
  'Galaxy Z Flip 5', 'Galaxy Z Flip 4', 'Galaxy Z Flip 3',

  // Note Series
  'Galaxy Note 20 Ultra', 'Galaxy Note 20',
  'Galaxy Note 10+', 'Galaxy Note 10',
  'Galaxy Note 9', 'Galaxy Note 8',

  // A Series
  'Galaxy A74', 'Galaxy A72', 'Galaxy A71', 'Galaxy A70',
  'Galaxy A54', 'Galaxy A53', 'Galaxy A52', 'Galaxy A51', 'Galaxy A50',
  'Galaxy A34', 'Galaxy A32', 'Galaxy A31', 'Galaxy A30',
  'Galaxy A24', 'Galaxy A23', 'Galaxy A22', 'Galaxy A21', 'Galaxy A20',
  'Galaxy A14', 'Galaxy A13', 'Galaxy A12', 'Galaxy A11', 'Galaxy A10',

  // J Series
  'Galaxy J8', 'Galaxy J7 Pro', 'Galaxy J7 Prime', 'Galaxy J7',
  'Galaxy J6', 'Galaxy J5 Prime', 'Galaxy J5', 'Galaxy J4', 'Galaxy J3'
],
Huawei: [
  // Mate Series
  'Mate 60 Pro+', 'Mate 60 Pro', 'Mate 60',
  'Mate 50 Pro', 'Mate 50',
  'Mate 40 Pro', 'Mate 40',
  'Mate 30 Pro', 'Mate 30',
  'Mate 20 Pro', 'Mate 20',

  // P Series
  'P60 Pro', 'P60',
  'P50 Pro', 'P50',
  'P40 Pro+', 'P40 Pro', 'P40',
  'P30 Pro', 'P30',
  'P20 Pro', 'P20',

  // Nova Series
  'Nova 12 Ultra', 'Nova 12 Pro', 'Nova 12',
  'Nova 11i', 'Nova 11', 'Nova 11 SE',
  'Nova 10 Pro', 'Nova 10', 'Nova 10 SE',
  'Nova 9', 'Nova 8', 'Nova 7i',
  'Nova 5T', 'Nova 3i',

  // Y Series
  'Y9a', 'Y9s', 'Y9 Prime (2019)',
  'Y8p', 'Y7a', 'Y7p',
  'Y6s', 'Y6 Pro (2019)',
  'Y5p', 'Y5 (2019)', 'Y3 (2018)'
],

    Google: ['Pixel 8 Pro', 'Pixel 8', 'Pixel 7a', 'Pixel Fold'],
    OnePlus: ['OnePlus 12', 'OnePlus 11', 'OnePlus Open'],
    Xiaomi: ['Xiaomi 14', 'Redmi Note 13 Pro+', 'POCO F5']
  },
  'Tablet': {
    Apple: ['iPad Pro M2 12.9"', 'iPad Pro M2 11"', 'iPad Air M1', 'iPad Mini 6'],
    Samsung: ['Tab S9 Ultra', 'Tab S9+', 'Tab S6 Lite', 'Tab A9'],
    Lenovo: ['Yoga Tab 13', 'Tab P11 Pro'],
    Huawei: [
  // MatePad Series
  'MatePad Pro 13.2', 'MatePad Pro 12.6', 'MatePad Pro 11',
  'MatePad 11.5', 'MatePad 10.4', 'MatePad SE', 'MatePad Paper',

  // MediaPad Series
  'MediaPad M6', 'MediaPad M5 Lite', 'MediaPad T5',
  'MediaPad T3', 'MediaPad M3 Lite', 'MediaPad T1'
],
    Microsoft: ['Surface Pro 9', 'Surface Go 3', 'Surface Duo 2'],
    Amazon: ['Fire HD 10', 'Fire HD 8', 'Fire 7']

  },
  'Laptop': {
    Dell: ['XPS 13 Plus', 'XPS 15', 'Inspiron 14', 'Alienware m16'],
    HP: ['Spectre x360', 'Omen 16', 'Envy x360'],
    Lenovo: ['ThinkPad X1 Carbon', 'Legion 5i', 'Yoga 7i'],
    Asus: ['ROG Zephyrus G14', 'VivoBook']
  },
  'MacBook': {
    Apple: ['MacBook Pro M3 14"', 'MacBook Pro M2 16"', 'MacBook Air M2 15"',
      'MacBook Air M1 13"', 'MacBook Pro Intel 2019']
  },
  'TV': {
    Samsung: ['QN90D Neo QLED', 'S95D OLED', 'TU7000'],
    LG: ['G4 OLED', 'C4 OLED', 'C1'],
    Sony: ['A95L QD-OLED', 'X95J', 'X900H']
  }
};

const Upload = () => {
  const { deviceType } = useParams();
  const [gadget, setGadget] = useState({
    imei: '',
    secondaryImei: '',
    serialNumber: '',
    brand: '',
    model: '',
    color: '',
    ownerDetails: {
      name: '',
      email: '',
      telephone: '',
      address: ''
    },
    status: 'active'
  });

  const [customBrand, setCustomBrand] = useState('');
  const [customModel, setCustomModel] = useState('');
  const [brandOptions, setBrandOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  // Load brand list based on device type
  useEffect(() => {
    const brands = deviceTypeBrandModelMap[deviceType]
      ? [...Object.keys(deviceTypeBrandModelMap[deviceType]), 'Other']
      : ['Other'];
    setBrandOptions(brands);
  }, [deviceType]);

  useEffect(() => {
    const models = deviceTypeBrandModelMap[deviceType]?.[gadget.brand] || [];
    setModelOptions([...models, 'Other']);
  }, [gadget.brand, deviceType]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('ownerDetails.')) {
      const field = name.split('.')[1];
      setGadget((prev) => ({
        ...prev,
        ownerDetails: {
          ...prev.ownerDetails,
          [field]: value
        }
      }));
    } else {
      setGadget((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const validateForm = () => {
    const errs = {};
    if ((deviceType === 'Mobile Device' || deviceType === 'Tablet') && !gadget.imei.trim()) {
      errs.imei = 'IMEI is required';
    }
    if (!(deviceType === 'Mobile Device' || deviceType === 'Tablet') && !gadget.serialNumber.trim()) {
      errs.serialNumber = 'Serial Number is required';
    }
    const brandValue = gadget.brand === 'Other' ? customBrand.trim() : gadget.brand.trim();
    const modelValue = gadget.model === 'Other' ? customModel.trim() : gadget.model.trim();
    if (!brandValue) errs.brand = 'Brand is required';
    if (!modelValue) errs.model = 'Model is required';
    if (!gadget.color.trim()) errs.color = 'Color is required';
    if (!gadget.ownerDetails.name.trim()) errs.name = 'Owner name is required';
    if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(gadget.ownerDetails.email)) {
      errs.email = 'Valid email is required';
    }
    if (!gadget.ownerDetails.telephone.trim()) errs.telephone = 'Telephone is required';
    if (!gadget.ownerDetails.address.trim()) errs.address = 'Address is required';
    return errs;
  };

  const resetForm = () => {
    setGadget({
      imei: '',
      secondaryImei: '',
      serialNumber: '',
      brand: '',
      model: '',
      color: '',
      ownerDetails: {
        name: '',
        email: '',
        telephone: '',
        address: ''
      },
      status: 'active'
    });
    setCustomBrand('');
    setCustomModel('');
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      const brandValue = gadget.brand === 'Other' ? customBrand.trim() : gadget.brand.trim();
      const modelValue = gadget.model === 'Other' ? customModel.trim() : gadget.model.trim();

      const gadgetData = {
        ...gadget,
        brand: brandValue,
        model: modelValue,
        deviceType
      };

      if (!gadgetData.imei) delete gadgetData.imei;
      if (!gadgetData.secondaryImei) delete gadgetData.secondaryImei;
      if (deviceType === 'Mobile Device' || deviceType === 'Tablet') {
        delete gadgetData.serialNumber;
      } else if (!gadgetData.serialNumber) {
        delete gadgetData.serialNumber;
      }

      const response = await apiFetch('/api/gadgets', 'POST', gadgetData);

      if (response.success) {
        alert('✅ Gadget uploaded successfully!');
        resetForm();
      } else {
        alert('❌ Upload failed: ' + response.message);
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert(`❌ Upload failed: ${error.message || 'Unexpected error'}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 6, mb: 6 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h4" color="primary" fontWeight="bold" gutterBottom>
          Upload Gadget Information
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" mb={2}>
          Device Type: <strong>{deviceType}</strong>
        </Typography>
        <Divider sx={{ my: 3 }} />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {(deviceType === 'Mobile Device' || deviceType === 'Tablet') ? (
              <>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="imei"
                    label="IMEI"
                    value={gadget.imei}
                    onChange={handleChange}
                    fullWidth
                    required
                    error={!!errors.imei}
                    helperText={errors.imei}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="secondaryImei"
                    label="Secondary IMEI (optional)"
                    value={gadget.secondaryImei}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
              </>
            ) : (
              <Grid item xs={12}>
                <TextField
                  name="serialNumber"
                  label="Serial Number"
                  value={gadget.serialNumber}
                  onChange={handleChange}
                  fullWidth
                  required
                  error={!!errors.serialNumber}
                  helperText={errors.serialNumber}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required error={!!errors.brand}>
                <InputLabel>Brand</InputLabel>
                <Select name="brand" value={gadget.brand} onChange={handleChange} label="Brand">
                  {brandOptions.map((brand) => (
                    <MenuItem key={brand} value={brand}>{brand}</MenuItem>
                  ))}
                </Select>
                <FormHelperText>{errors.brand}</FormHelperText>
              </FormControl>
              {gadget.brand === 'Other' && (
                <TextField
                  name="customBrand"
                  label="Enter Brand"
                  value={customBrand}
                  onChange={(e) => setCustomBrand(e.target.value)}
                  fullWidth
                  required
                  sx={{ mt: 2 }}
                />
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required error={!!errors.model}>
                <InputLabel>Model</InputLabel>
                <Select name="model" value={gadget.model} onChange={handleChange} label="Model">
                  {modelOptions.map((model) => (
                    <MenuItem key={model} value={model}>{model}</MenuItem>
                  ))}
                </Select>
                <FormHelperText>{errors.model}</FormHelperText>
              </FormControl>
              {gadget.model === 'Other' && (
                <TextField
                  name="customModel"
                  label="Enter Model"
                  value={customModel}
                  onChange={(e) => setCustomModel(e.target.value)}
                  fullWidth
                  required
                  sx={{ mt: 2 }}
                />
              )}
            </Grid>

            <Grid item xs={12}>
              <TextField
                name="color"
                label="Color"
                value={gadget.color}
                onChange={handleChange}
                fullWidth
                required
                error={!!errors.color}
                helperText={errors.color}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" color="secondary" fontWeight="bold" gutterBottom>
                Owner Details
              </Typography>
            </Grid>

            {['name', 'email', 'telephone', 'address'].map((field) => (
              <Grid item xs={12} sm={field === 'address' ? 12 : 6} key={field}>
                <TextField
                  name={`ownerDetails.${field}`}
                  label={`Owner ${field.charAt(0).toUpperCase() + field.slice(1)}`}
                  value={gadget.ownerDetails[field]}
                  onChange={handleChange}
                  fullWidth
                  required
                  error={!!errors[field]}
                  helperText={errors[field]}
                />
              </Grid>
            ))}

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required error={!!errors.status}>
                <InputLabel>Status</InputLabel>
                <Select
                  name="status"
                  value={gadget.status}
                  label="Status"
                  onChange={handleChange}
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="stolen">Stolen</MenuItem>
                  <MenuItem value="lost">Lost</MenuItem>
                </Select>
                <FormHelperText>{errors.status}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                startIcon={<UploadIcon />}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Uploading...' : 'Upload Gadget'}
              </Button>
            </Grid>
          </Grid>
        </form>

        <Box mt={4} textAlign="center">
          <Button
            component={Link}
            to="/"
            variant="outlined"
            color="secondary"
            startIcon={<ArrowBackIcon />}
          >
            Back to Homepage
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default Upload;


